module.exports = __webpack_public_path__ + "img/rocket.6d73e1c2.png";